import React, { useEffect } from "react";
import { PATHS } from "@constants/Paths";
import { useEndProxySession, useLoader } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { hasAcceptedLatestTerms } from "@utils";
import { RoleAliases } from "@constants/Roles";
export const AuthLayout = () => {
    const { onLogin, user, isAdmin, proxyUser } = useAuthContext();
    const [endProxySession, token, endProxySessionLoading] = useEndProxySession();
    const { setLoader, loader } = useLoader();
    const location = useLocation();
    useEffect(() => {
        if (!token)
            return;
        onLogin({ token: token }, true);
    }, [token]);
    useEffect(() => {
        setLoader(endProxySessionLoading, "endProxySessionLoading");
        return () => setLoader(false, "endProxySessionLoading");
    }, [endProxySessionLoading]);
    const handleSwitchUser = () => {
        endProxySession();
    };
    if (!user) {
        return React.createElement(Navigate, { to: PATHS.LOGIN, replace: true, state: { redirectTo: location } });
    }
    if (loader || isAdmin || (proxyUser === null || proxyUser === void 0 ? void 0 : proxyUser.roleAlias) === RoleAliases.ADMIN || hasAcceptedLatestTerms(user)) {
        return React.createElement(Outlet, { context: { onSwitchUser: handleSwitchUser } });
    }
    return React.createElement(Navigate, { to: PATHS.TERMS_CONDITIONS_AGREEMENT, replace: true, state: { redirectTo: location } });
};
export default AuthLayout;
